import Button from '@mui/material/Button';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useIntl } from 'react-intl';
import { Link as RouterLink } from 'react-router-dom';
import { resolvePath, useQuery } from '../../routes';
import { orderConfirmation } from '../../layout/routes';

// Primary retry action per Billing 2.0 payment status design.
const ButtonToOrderConfirmation = () => {
  const intl = useIntl();
  const { queryDictionary } = useQuery();

  const accountId = useQuery().get('accountId');
  return (
    <Button
      id="goto-order-confirmation-page"
      variant="contained"
      size="large"
      disableElevation
      startIcon={<RefreshIcon sx={{ fontSize: 17 }} />}
      sx={{
        height: 46,
        px: '22px',
        borderRadius: '10px',
        backgroundColor: '#0F8461',
        color: '#FFFFFF',
        fontSize: 14,
        fontWeight: 600,
        textTransform: 'none',
        whiteSpace: 'nowrap',
        '&:hover': {
          backgroundColor: '#0B6B4E',
        },
      }}
      component={RouterLink}
      to={resolvePath(orderConfirmation, undefined, {
        ...queryDictionary,
        accountId: Number(accountId),
      }, false)}
    >
      {intl.formatMessage({ id: 'payment_status.button.back_order_confirmation' })}
    </Button>
  );
};

export default ButtonToOrderConfirmation;
